import { render, staticRenderFns } from "./YKCUnprocessedPayments.vue?vue&type=template&id=610836e8&"
import script from "./YKCUnprocessedPayments.vue?vue&type=script&lang=js&"
export * from "./YKCUnprocessedPayments.vue?vue&type=script&lang=js&"
import style0 from "./YKCUnprocessedPayments.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports